import React from "react";
import { Helmet } from "react-helmet";

const SEO: React.FC = () => {
  const host = window.location.hostname.toLowerCase();

  let ogImage = "/og-image.png"; // default Athena
  let title = "Temple Athena";
  let description = "The eternal temple of Athena, goddess of wisdom and strategy.";

  if (host.includes("jennifergrayson.ai")) {
    ogImage = "/og-image-jennifergrayson.jpeg";
    title = "Jennifer Grayson";
    description = "The temple of Beauty";
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;